export class DocumentoModel {

    numFacturaFabril: string;
    numCobroFabril: string;
    cliente: string;
    anios: any[];
    meses: any[];
    empresas: any[];
    oficinas: any[];

    constructor(obj: any) {
        this.numFacturaFabril = obj.numFacturaFabril;
        this.numCobroFabril = obj.numCobroFabril;
        this.cliente = obj.cliente;
        this.anios = obj.anios || [];
        this.meses = obj.meses || [];
        this.empresas = obj.empresas || []; //["1001","1002"] || [];
        this.oficinas = obj.oficinas || [];
    }
}